import { env } from "@config/env";

export const DAYS = [
  { short: "Mon", full: "Monday", value: "Mon" },
  { short: "Tue", full: "Tuesday", value: "Tue" },
  { short: "Wed", full: "Wednesday", value: "Wed" },
  { short: "Thu", full: "Thursday", value: "Thu" },
  { short: "Fri", full: "Friday", value: "Fri" },
  { short: "Sat", full: "Saturday", value: "Sat" },
  { short: "Sun", full: "Sunday", value: "Sun" },
] as const;

export const ROUTE_PURPOSES_KEYS = [
  "office",
  "education",
  "fitness",
  "sports",
  "travel",
  "event",
  "other",
] as const;
/** Purpose icon files live under `public/icons/svg`. */
export const routePurposeIconSrc = (icon: string) => `/icons/svg/${icon}.svg`;

export const ROUTE_PURPOSES = {
  office: {
    label: "Office",
    emoji: "💼",
    icon: "briefcase",
    detail: {
      question: "Where are you working?",
      placeholder: "e.g. Amazon, Tesla, Google",
    },
  },

  education: {
    label: "University",
    emoji: "🎓",
    icon: "cap",
    detail: {
      question: "Where are you studying?",
      placeholder: "e.g. University of Toronto, Harvard, MIT",
    },
  },

  fitness: {
    label: "Fitness",
    emoji: "👟",
    icon: "shoe",
    detail: {
      question: "What fitness activity are you doing?",
      placeholder: "e.g. Gym at XYZ Fitness",
    },
  },

  sports: {
    label: "Sports",
    emoji: "🏅",
    icon: "medal",
    detail: {
      question: "What sport or activity is it?",
      placeholder: "e.g. Padel, cricket, football",
    },
  },

  travel: {
    label: "Travel",
    emoji: "🧳",
    icon: "luggage",
    detail: {
      question: "What is this travel for?",
      placeholder: "e.g. Going to New York for a conference",
    },
  },

  event: {
    label: "Event",
    emoji: "🎫",
    icon: "ticket",
    detail: {
      question: "What event are you going to?",
      placeholder: "e.g. Marathon, concert, wedding",
    },
  },

  other: {
    label: "Other",
    emoji: "📍",
    icon: "pushpin",
    detail: {
      question: "What are you heading there for?",
      placeholder: "e.g. Shopping, family visit, meetup",
    },
  },
} as const;

export const isLocal = env.isDev;
export const isProd = env.isProd;
export const isDev = !isProd;

export const BASE_URL = env.appUrl();
export const MARKETING_URL = env.marketingUrl();
export const LANGUAGE = "en";
